import { Component } from '@angular/core';
import { Toast } from 'primeng/toast';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from '../infrastructure/shared/components/loader/loader';

@Component({
  selector: 'app-root',
  imports: [Toast, RouterOutlet, LoaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
